import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import ScoreChooser from './ScoreChooser';
import Score from './Score';
import config from "../config";

interface IMatchParams {
  pollId: string;
}

interface IPollProps extends RouteComponentProps {
  currentUserScore: number;
  match: {
    isExact: any;
    path: any;
    url: any;
    params: IMatchParams;
  };
}

const Poll: React.SFC<IPollProps> = (props) => {
  const {
    currentUserScore,
    match: {
      params: { pollId },
    },
  } = props;

  const color = currentUserScore ? config.formScale[currentUserScore].color : "inherit"

  return (
    <div className="Poll" style={{ height: "100vh", width: "100vw", backgroundColor: color}}>
      {currentUserScore === 0 && <ScoreChooser />}
      {currentUserScore !== 0 && <Score {...props} pollId={pollId} />}
    </div>
  )
};

const mapStateToProps = (state: any) => {
  return {
    currentUserScore: state.currentUserScore,
  };
};

export default connect(mapStateToProps)(Poll);
